import React from 'react'
import ButtonStartIcon from '../button/ButtonStartIcon';
import { useDispatch, useSelector } from 'react-redux';
import { toggleAlertModule } from '../../store/actions/alert.actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

const DialogAlertSave = ({ open }) => {
  const alertSave = useSelector(state => state?.alert?.save || {})
  const dispatch = useDispatch()

  const onCancel = () => {
    dispatch(toggleAlertModule(false, alertSave.module, alertSave.mode, alertSave.onSave, alertSave.onDontSave))
  }
  const onSave = () => {
    if (alertSave.onSave) {
      alertSave.onSave()
    }
    onCancel()
  }

  const onDontSave = () => {
    if (alertSave.onDontSave) {
      alertSave.onDontSave()
    }
    dispatch(toggleAlertModule())
  }

  return (
    <Dialog
      id={`dialog-alert-save`}
      open={open}
      disableEscapeKeyDown={false}
      maxWidth='xs'
      className={`bg-background`}
      style={{ backgroundColor: 'transparent' }}
      aria-describedby='dialog-alert-save-describedby'
      aria-labelledby={`dialog-alert-save`}
    >
      <Typography color="primary" variant='h6' className='uppercase px-4 py-1 bg-background'>{`${alertSave.mode} module ${alertSave.module}`}</Typography>
      <DialogContent>
        <div className='flex items-center gap-4'>
          <FontAwesomeIcon icon={['fal', 'triangle-exclamation']} className='text-8xl text-muted-foreground opacity-50' />
          <div className='py-4'>
            <Typography component={'p'} variant='inherit' className=' text-xl'>
              You have unsaved changes, do you want to save them?
            </Typography>
            <Typography component={'p'} variant='inherit' className='py-2 text-muted-foreground opacity-75 text-sm'>
              If you don't save, your changes will be lost.
            </Typography>
          </div>
        </div>
      </DialogContent>
        <DialogActions>
          <ButtonStartIcon
            onClick={onDontSave}
            variant='outlined'
            color='primary'
            startIcon={["fal","circle-exclamation"]}
            className='text-nowrap px-4'
          >
            Don't Save
          </ButtonStartIcon>
          <div className='flex justify-end gap-2 w-full'>
            <ButtonStartIcon
              onClick={onCancel}
              color='secondary'
              variant='contained'
              startIcon={["fal","times"]}
            >
              cancel
            </ButtonStartIcon>
            <ButtonStartIcon
              onClick={onSave}
              color='primary'
              variant='contained'
              startIcon={["fal","check"]}
            >
              save
            </ButtonStartIcon>
          </div>
        </DialogActions>
    </Dialog>
  )
}

export default DialogAlertSave